export default __webpack_public_path__ + "static/media/AbrahamAnswer.54aa0579.png";